import React from 'react';
import { classNames } from '../../utils/classNames';

export const Button = ({ children, className, variant = 'primary', ...props }) => {
  const variants = {
    primary: 'bg-accent text-white hover:opacity-95 dark:text-slate-950',
    secondary: 'border border-border bg-white/72 text-text hover:bg-white dark:bg-slate-950/35 dark:hover:bg-slate-950/60',
    ghost: 'bg-transparent text-text hover:bg-white/55 dark:hover:bg-white/5',
    danger: 'bg-rose-600 text-white hover:bg-rose-500'
  };

  return (
    <button
      className={classNames(
        'inline-flex cursor-pointer items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-50',
        variants[variant],
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};
